<template>
  <Modal
    :value="open"
    :onClose="close"
    :close="false"
    title="Cadastrar nova administradora de cartões"
  >
    <b-row>
      <b-col md="3" lg="6" sm="3">
        <Input
          id="administradoraName"
          ref="administradoraName"
          v-model="value.name"
          label="Nome"
          placeholder="Informe uma descrição"
          labelBold
        />
      </b-col>
      <b-col md="3" lg="6" sm="3">
        <Input
          id="identification"
          class="input"
          label="CNPJ"
          v-model="value.identification"
          placeholder="Informe um CNPJ"
          :mask="['UU.UUU.UUU/UUUU-UU']"
          labelBold
        />
      </b-col>
      <b-col md="3" lg="6" sm="3" class="mt-3" v-if="showFinanceAgent">
        <SelectClient
          label="Agente financeiro"
          :client="financeAgent"
          :change="changeFinanceAgent"
          :filters="filters"
        />
      </b-col>
    </b-row>
    <div class="confirm-buttons">
      <Button type="error" @click="close()">Fechar</Button>
      <Button type="success" @click="save()">Gravar</Button>
    </div>
  </Modal>
</template>

<script>
import { Modal } from '@/components';
import { Button, Input } from '@/components/Form';
import { SelectClient } from '../Form';
import AdministradorasMixin from '../../mixins/AdministradorasMixin';
import { ClientMixin } from '../../../../../Application';

export default {
  name: 'ModalRegisterCardManager',
  components: {
    Modal,
    Button,
    SelectClient,
    Input,
  },
  mixins: [AdministradorasMixin, ClientMixin],
  data() {
    return {
      value: {},
      showFinanceAgent: false,
      financeAgent: null,
      filters: {
        withIdentification: true,
      },
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Function,
      required: true,
    },
    onSave: {
      type: Function,
    },
  },
  async mounted() {
    await this.getClient();
    this.showFinanceAgent = this.client.fiscal.emissor.enable1601Sped;
  },
  methods: {
    async save() {
      this.value.identification = this.value.identification.replace(/[^A-Z0-9]+/g, '');
      this.value.financeAgent = this.financeAgent ? this.financeAgent.id : null;
      this.onSave(this.value);
    },
    changeFinanceAgent(selectedCliente) {
      this.financeAgent = selectedCliente;
    },
  },
  watch: {
    open() {
      if (this.open) {
        this.$nextTick(() => {
          this.$refs.administradoraName.$children[1].focus();
        });
      }
    },
  },
};
</script>
